import { z } from "zod";
import { BaseResponseSchema } from "../../base/response/BaseResponseSchema";

export const PaymentSchema = z.nullable(z.object({
    id: z.string(),
    property_id: z.string(),
    booking_id: z.string(),
    booking_room_id: z.string(),
    user_id: z.nullable(z.string()).optional(),
    date_payment: z.string(),
    payment_type: z.string(),
    amount: z.string(),
    surcharge: z.string().optional(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
}));
export const DeletePaymentResponseSchema = BaseResponseSchema(PaymentSchema);
export type DeletePaymentResponse = z.infer<typeof DeletePaymentResponseSchema>;